import * as React from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { ButtonGroup } from "components/bootstrap";
import { normalizeIfAllMessagesRange } from "views/logic/queries/NormalizeTimeRange";
import { SEARCH_BUTTON_WIDTH } from "views/components/searchbar/SearchButton";
import TimeRangePickerButton from "views/components/time-range-picker/TimeRangePickerButton";
import RangePresetDropdown from "./TimeRangePresetDropdown";
const StyledRangePresetDropdown = styled(RangePresetDropdown)`
  padding: 6px 5px 6px 6px;
`;
const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  align-items: start;
  width: ${SEARCH_BUTTON_WIDTH}px;
`;
const TimeRangeFilterButtons = ({
  disabled = false,
  hasErrorOnMount = false,
  onPresetSelectOpen,
  setCurrentTimeRange,
  showPresetDropdown = true,
  toggleShow,
  limitDuration,
  submitOnPresetChange = true
}) => {
  const { submitForm, isValid } = useFormikContext();
  const _onClick = (e) => {
    e.currentTarget.blur();
    toggleShow();
  };
  const selectRelativeTimeRangePreset = (timerange) => {
    setCurrentTimeRange(normalizeIfAllMessagesRange(timerange));
    if (isValid && submitOnPresetChange) {
      submitForm();
    }
  };
  const _onPresetSelectToggle = (open) => {
    if (open) {
      onPresetSelectOpen();
    }
  };
  return /* @__PURE__ */ React.createElement(StyledButtonGroup, null, /* @__PURE__ */ React.createElement(TimeRangePickerButton, { hasError: hasErrorOnMount, disabled, onClick: _onClick }), showPresetDropdown && /* @__PURE__ */ React.createElement(
    StyledRangePresetDropdown,
    {
      limitDuration,
      disabled,
      displayTitle: false,
      onChange: selectRelativeTimeRangePreset,
      onToggle: _onPresetSelectToggle,
      header: "Select time range",
      bsSize: null
    }
  ));
};
export default TimeRangeFilterButtons;
